import { Component } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { UserAccessService } from 'src/app/services/user-access.service';

@Component({
  selector: 'app-recover-mail',
  templateUrl: './recover-mail.component.html',
  styleUrls: ['./recover-mail.component.css']
})
export class RecoverMailComponent {

  constructor(
    private userAccessService: UserAccessService,
    private alertService: AlertService 
  ) { }

  // Aquí puedes agregar la lógica necesaria para la recuperación de correo
  // Por ejemplo, un método para enviar un correo de recuperación
  recoverEmail(email: string): void {
    this.userAccessService.sendMailForLastBook(email)
      .then((res) => {
        console.log('Correo de recuperación enviado exitosamente.', res);
        this.alertService.alert(`Compruebe la bandeja de entrada de su correo "${email}". Si es el correo que ha entregado a la clínica, recibirá un enlace para acceder a sus resultados.`);
        console.log(`Compruebe la bandeja de entrada de su correo "${email}". Si es el correo que ha entregado a la clínica recibirá un enlace para acceder a sus resultados.`);
      })
      .catch(error => {
        console.error('Error al enviar el correo de recuperación');
      });
    console.log(`Recuperación de correo solicitada para: ${email}`);
    // Implementa la lógica de recuperación aquí
  }
}
